module.exports = __webpack_public_path__ + "static/media/lang4.c391fbfb.mp3";